import React, { useEffect, useState } from 'react';
import PharmacyBanner from 'src/Components/WebsiteComponents/PharmacyBanner';
import WebTopCategories from 'src/Components/WebsiteComponents/WebTopCategories';
import TopBrandsSlider from 'src/Components/WebsiteComponents/TopBrandsSlider';
import WebCategoriesBanners from 'src/Components/WebsiteComponents/WebCategoriesBanners';
import dummyImg from 'src/assets/images/banner-dummy-pic.png'
import { Link } from 'react-router-dom';
import httpRequest from 'src/helpers/httpRequest';
import { toast } from 'react-toastify';
import SplashScreen from 'src/Components/SplashScreen';
import { Skeleton } from '@mui/material';

interface IHomePageInterface {
    sectionOne: { mainBanner: string; };
    sectionTwo: { mainCategoryName: string; mainCategoryId: string; topCategoryImage: string; }[];
    sectionThree: { brandId: string; brandName: string; topBrandImage: string; }[];
    sectionFour: { categoryBanner: string; mainCategoryId: string; mainCategoryName: string; }[];
    sectionFive: { categoryBanner: string; mainCategoryId: string; mainCategoryName: string; }[];
    sectionSix: { categoryBanner: string; mainCategoryId: string; mainCategoryName: string; }[];
    sectionSeven: { mainCategory: string; promotionalBanner: string; _id: string; }[];
};

const PharmaProducts = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IHomePageInterface | null>(null);
    const fetch = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<IHomePageInterface>({ path: "/website-manage/home" });
        if (res) {
            setData(res);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, []);
    return (
        <>
            <div className='pharmacy-banner'>
                <div className='container-1400'>
                    <PharmacyBanner
                        loader={isLoader}
                        mainBanner={data?.sectionOne?.mainBanner || ""}
                    />
                    <WebTopCategories
                        category="main-category"
                        loader={isLoader}
                        data={(data?.sectionTwo || [])?.map(v => ({ images: v?.topCategoryImage, id: v?.mainCategoryId, name: v?.mainCategoryName }))}
                    />
                </div>
            </div>
            <div className='bg-white py-4'>
                <div className='container-1400'>
                    <div className='flex justify-between items-end'>
                        <h2 className='font-size-28px font-Poppins-SemiBold theme-color-green'>Top Brands Your Way</h2>
                        <Link to='/all-brands' className='theme-color-green underline font-Poppins-SemiBold fonts-size-16px'>See all</Link>
                    </div>
                    <div className='py-4'>
                        <TopBrandsSlider
                            category="brand"
                            loader={isLoader}
                            data={(data?.sectionThree || [])?.map(v => ({ id: v?.brandId, image: v?.topBrandImage, name: v?.brandName }))}
                        />
                    </div>
                    <WebCategoriesBanners
                        category="main-category"
                        loader={isLoader}
                        data={data?.sectionFour || []}
                    />
                    <WebCategoriesBanners
                        category="main-category"
                        loader={isLoader}
                        data={data?.sectionFive || []}
                    />
                    <WebCategoriesBanners
                        category="main-category"
                        loader={isLoader}
                        data={data?.sectionSix || []}
                    />
                    <div className='py-4 flex justify-between'>
                        {isLoader ?
                            Array.from({ length: 2 }).map((_, index) => (
                                <Skeleton key={index} variant="rectangular" className="thumbnail-img-left-side" height="20vh" />
                            ))
                            :
                            data?.sectionSeven?.map((item, index) => (
                                <Link className='thumbnail-img-left-side-main' to={`/pharmacy/main-category/${item?.mainCategory}/view`}>
                                    <img
                                        key={index}
                                        className='thumbnail-img-left-side'
                                        src={`${item?.promotionalBanner}`}
                                        alt={'Banner'}
                                    />
                                </Link>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default PharmaProducts;